import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { LoyaltyProgramRelease } from '../entities/loyalty-program-release';



export class LoyaltyProgramReleaseRequest extends BaseRequest {

  loyaltyProgramRelease : LoyaltyProgramRelease;

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.loyaltyProgramRelease = new LoyaltyProgramRelease()
  }
}